// src/components/specific/ProductCard.js
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '../common/Button';
import './ProductCard.css';

const ProductCard = ({ product, isAuthenticated }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [addedToCart, setAddedToCart] = useState(false);
  const { user } = useSelector((state) => state.auth);

  const {
    id,
    name,
    price,
    image,
    category,
    rating,
    description = "No description available",
    stock = 10
  } = product;

  const handleAddToCart = () => {
    setAddedToCart(true);
    // In a real app, you would dispatch an action to add to cart
    setTimeout(() => setAddedToCart(false), 2000);
  };

  const handleQuickView = () => {
    setIsExpanded(!isExpanded);
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<span key={i} className="star full">★</span>);
    }

    if (hasHalfStar) {
      stars.push(<span key="half" className="star half">★</span>);
    }

    const emptyStars = 5 - stars.length;
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<span key={`empty-${i}`} className="star empty">★</span>);
    }

    return stars;
  };

  return (
    <div className="product-card">
      <div className="product-image">
        <img src={image || '/images/placeholder-product.jpg'} alt={name} />
        <div className="product-category">{category}</div>
        {stock < 5 && <div className="low-stock">Low Stock</div>}
      </div>

      <div className="product-info">
        <h3 className="product-name">{name}</h3>
        <div className="product-rating">
          {renderStars(rating)}
          <span className="rating-value">({rating})</span>
        </div>
        <p className="product-price">${price.toFixed(2)}</p>
        
        <div className="product-actions">
          {isAuthenticated ? (
            <>
              <Button 
                onClick={handleAddToCart}
                className="add-to-cart-btn"
                disabled={addedToCart}
              >
                {addedToCart ? 'Added to Cart!' : 'Add to Cart'}
              </Button>
              <Button 
                variant="outline" 
                onClick={handleQuickView}
                className="quick-view-btn"
              >
                {isExpanded ? 'Less Info' : 'Quick View'}
              </Button>
            </>
          ) : (
            <p className="login-prompt">Please login to purchase</p>
          )}
        </div>

        {isExpanded && (
          <div className="product-details-expanded">
            <p className="product-description">{description}</p>
            <div className="product-meta">
              <span>SKU: {id}</span>
              <span className={`stock-status ${stock < 5 ? 'low' : 'in-stock'}`}>
                {stock < 5 ? `${stock} left` : 'In Stock'}
              </span>
            </div>
            {user && (
              <div className="user-specific">
                <p>Free shipping for your membership level</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCard;